export const SN_CHANNEL = 'channel'
export const CHANNEL_INVENTORY_CHANNELS_UPDATED = SN_CHANNEL + '/INVENTORY_CHANNELS_UPDATED'
export const CHANNEL_JOBS_UPDATED = SN_CHANNEL + '/JOBS_UPDATED'
export const CHANNEL_SERVICE_STATUS_DESC_UPDATED = SN_CHANNEL + '/SERVICE_STATUS_DESC_UPDATED'
export const CHANNEL_TEMPORAL_EXPRESSION_UPDATED = SN_CHANNEL + '/TEMPORAL_EXPRESSION_UPDATED'